import { takeLatest, call, put } from "redux-saga/effects";
import { request, showNotification } from "@thewebops/admin-panel";
import actions from "./actions";

function* exportExercise(action) {
  const { item } = action.payload;
  const { success, failure } = actions.exportExercise;
  try {
    yield call(request, {
      url: `admin/export_documents`,
      method: "post",
      authenticated: true,
      data: {
        exportable_id: item.id,
        exportable_type: 'Exercise',
      }
    });
    showNotification('Exercise', "success");
    yield put(success(item));
  } catch (error) {
    yield put(failure());
  }
}


function* watchEntityexportExercise() {
  const { request } = actions.exportExercise;
  yield takeLatest(request, exportExercise);
}


export default [watchEntityexportExercise];
